"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check

var _vehicles = require("@busbud/int-schemas/lib/vehicles");

var _animals = require("./animals");

var _animals2 = _interopRequireDefault(_animals);

var _boardingRequirements = require("./boarding-requirements");

var _boardingRequirements2 = _interopRequireDefault(_boardingRequirements);

var _luggage = require("./luggage");

var _luggage2 = _interopRequireDefault(_luggage);

var _oversizedLuggage = require("./oversized-luggage");

var _oversizedLuggage2 = _interopRequireDefault(_oversizedLuggage);

var _refundAndExchange = require("./refund-and-exchange");

var _refundAndExchange2 = _interopRequireDefault(_refundAndExchange);

var _translator = require("../translator");

var _translator2 = _interopRequireDefault(_translator);

var _utils = require("../utils");

var Utils = _interopRequireWildcard(_utils);

var _v = require("../v2");

var _v2 = _interopRequireDefault(_v);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BusbudTerms = function () {
  /**
   * Creates a BusbudTerms instance.
   *
   * @param {object} phrases - Translation key/copy mapping.
   * @param {string} locale - SupportedLocale
   */
  function BusbudTerms(phrases, locale) {
    _classCallCheck(this, BusbudTerms);

    this.translator = /** @type {Translator.Service} */new _translator2.default(phrases);
    this.v2 = new _v2.default(phrases, locale);
    this.locale = locale;
  }

  /**
   * Builds an array containing all term sections.
   *
   * @param {object} params
   * @param {TicketType} params.ticket_type
   * @param {Terms.Content} params.terms
   * @param {Array<Operator>} params.operators
   * @param {TripType} params.trip_type
   * @param {VehicleType|undefined} [params.vehicle_type]
   * @param {object|undefined} params.options
   * @returns {Array<Results.Section>}
   */


  _createClass(BusbudTerms, [{
    key: "buildAllTerms",
    value: function buildAllTerms(_ref) {
      var ticket_type = _ref.ticket_type,
          terms = _ref.terms,
          operators = _ref.operators,
          trip_type = _ref.trip_type,
          _ref$vehicle_type = _ref.vehicle_type,
          vehicle_type = _ref$vehicle_type === undefined ? _vehicles.VehicleType.Bus : _ref$vehicle_type,
          _ref$options = _ref.options,
          options = _ref$options === undefined ? {} : _ref$options;

      var translator = Utils.translatorFactory(this.translator, options);

      var all_terms = [(0, _refundAndExchange2.default)(translator, terms, trip_type, operators, options, this.locale), (0, _boardingRequirements2.default)({
        translator: translator,
        ticket_type: ticket_type,
        terms: terms,
        operators: operators,
        vehicle_type: vehicle_type,
        options: options
      }), (0, _luggage2.default)(translator, terms), (0, _oversizedLuggage2.default)(translator, terms), (0, _animals2.default)(translator, terms)];

      return (/** @type {Array<Results.Section>} */all_terms.filter(function (term_section) {
          return term_section !== null;
        })
      );
    }

    /**
     * @param {object} params
     * @param {TicketType} params.ticket_type
     * @param {Terms.Content} params.terms
     * @param {Array<Operator>} params.operators
     * @param {VehicleType|undefined} [params.vehicle_type]
     * @param {object|undefined} params.options
     * @returns {Results.Section}
     */

  }, {
    key: "buildBoardingRequirements",
    value: function buildBoardingRequirements(_ref2) {
      var ticket_type = _ref2.ticket_type,
          terms = _ref2.terms,
          operators = _ref2.operators,
          _ref2$vehicle_type = _ref2.vehicle_type,
          vehicle_type = _ref2$vehicle_type === undefined ? _vehicles.VehicleType.Bus : _ref2$vehicle_type,
          _ref2$options = _ref2.options,
          options = _ref2$options === undefined ? {} : _ref2$options;

      var translator = Utils.translatorFactory(this.translator, options);

      return (0, _boardingRequirements2.default)({
        translator: translator,
        ticket_type: ticket_type,
        terms: terms,
        operators: operators,
        vehicle_type: vehicle_type,
        options: options
      });
    }

    /**
     * @param {object} params
     * @param {Terms.Content} params.terms
     * @param {object|undefined} params.options
     * @returns {Results.Section}
     */

  }, {
    key: "buildLuggageTerms",
    value: function buildLuggageTerms(_ref3) {
      var terms = _ref3.terms,
          _ref3$options = _ref3.options,
          options = _ref3$options === undefined ? {} : _ref3$options;

      var translator = Utils.translatorFactory(this.translator, options);

      return (0, _luggage2.default)(translator, terms);
    }

    /**
     * @param {object} params
     * @param {Terms.Content} params.terms
     * @param {object|undefined} params.options
     * @returns {Results.Section|null}
     */

  }, {
    key: "buildOversizedLuggageTerms",
    value: function buildOversizedLuggageTerms(_ref4) {
      var terms = _ref4.terms,
          _ref4$options = _ref4.options,
          options = _ref4$options === undefined ? {} : _ref4$options;

      var translator = Utils.translatorFactory(this.translator, options);

      return (0, _oversizedLuggage2.default)(translator, terms);
    }

    /**
     * @param {object} params
     * @param {Terms.Content} params.terms
     * @param {object|undefined} params.options
     * @returns {Results.Section|null}
     */

  }, {
    key: "buildAnimalTerms",
    value: function buildAnimalTerms(_ref5) {
      var terms = _ref5.terms,
          _ref5$options = _ref5.options,
          options = _ref5$options === undefined ? {} : _ref5$options;

      var translator = Utils.translatorFactory(this.translator, options);

      return (0, _animals2.default)(translator, terms);
    }

    /**
     * @param {object} params
     * @param {Terms.Content} params.terms
     * @param {TripType} params.trip_type
     * @param {object|undefined} params.options
     * @param {Operator[]|undefined} params.operators
     * @returns {Results.Section}
     */

  }, {
    key: "buildRefundAndExchangeTerms",
    value: function buildRefundAndExchangeTerms(_ref6) {
      var terms = _ref6.terms,
          trip_type = _ref6.trip_type,
          _ref6$options = _ref6.options,
          options = _ref6$options === undefined ? {} : _ref6$options,
          _ref6$operators = _ref6.operators,
          operators = _ref6$operators === undefined ? [] : _ref6$operators;

      var translator = Utils.translatorFactory(this.translator, options);

      return (0, _refundAndExchange2.default)(translator, terms, trip_type, operators, options, this.locale);
    }
  }]);

  return BusbudTerms;
}();

exports.default = BusbudTerms;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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